export default [
    {
      title: "Code",
      key: "code",
      scopedSlots: { customRender: "code" }
    },
    {
      title: "Total Payment",
      key: "total_payment",
      scopedSlots: { customRender: "total_payment" }
    },
    {
      title: "Total Penerimaan",
      key: "total_accepted",
      scopedSlots: { customRender: "total_accepted" }
    },
    {
      title: "IsApproved",
      key: "approved",
      scopedSlots: { customRender: "approved" }
    },
  ];
  